import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'input',
      label: '素材标题',
      placeholder: '请输入素材标题'
    },
    {
      field: 'url',
      type: 'input',
      label: '素材链接',
      placeholder: '请输入素材链接'
    },
    {
      field: 'consumerNickName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'accessTime',
      type: 'datepicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
